import React from 'react';
import { Box, Heading, Text, Button, VStack, Code } from '@chakra-ui/react';

interface ErrorFallbackProps {
  error: Error | null;
  resetError: () => void;
}

export const errorFallback: React.FC<ErrorFallbackProps> = ({
  error,
  resetError,
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      bg="gray.50"
      px={4}
    >
      <VStack spacing={6} maxWidth="600px">
        <Heading as="h1" size="xl" color="red.600">
          Oops! Something went wrong
        </Heading>

        <Text fontSize="lg" color="gray.700" textAlign="center">
          We're sorry, but an unexpected error occurred. Please try refreshing
          the page or contact support if the problem persists.
        </Text>

        {error && (
          <Box
            width="100%"
            padding={4}
            bg="red.50"
            borderRadius="md"
            borderWidth="1px"
            borderColor="red.200"
          >
            <Text fontWeight="bold" color="red.800" mb={2}>
              Error Details:
            </Text>
            <Code
              display="block"
              whiteSpace="pre-wrap"
              padding={3}
              bg="white"
              borderRadius="sm"
              fontSize="sm"
              color="red.700"
            >
              {error.toString()}
            </Code>
          </Box>
        )}

        <Button
          colorScheme="blue"
          size="lg"
          onClick={resetError}
          width="200px"
        >
          Try Again
        </Button>

        <Button
          variant="link"
          colorScheme="gray"
          onClick={() => window.location.reload()}
        >
          Refresh Page
        </Button>
      </VStack>
    </Box>
  );
};
